import MyBerlitzLessonGroup from '@classes/LessonGroup'
import WithUserTime, { WithUserTimeProps } from '@hocs/WithUserTime'
import { StoreProps } from '@interfaces/StoreState'
import { getEndDate, getStartDate } from '@layouts/PendingLessons/Layout/utils'
import { GET_LESSON_GROUPS } from '@queries/index'
import { setPendingLessonError, setPendingLessonLoading, setPendingLessons } from '@redux/actions/pendingLessons'
import React, { useEffect, useState } from 'react'
import { withApollo, WithApolloClient } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'

export type Props = WithApolloClient<WithUserTimeProps>

const PendingLessonsTabQuery: React.FC<Props> = ({ client, toUserDate }) => {
  const { InstructorId } = useSelector(({ userProfile }: StoreProps) => ({
    InstructorId: userProfile?.info?.SFId,
  }))
  const [StartDateTime] = useState(getStartDate())
  const [EndDateTime] = useState(getEndDate())

  const dispatch = useDispatch()

  const fetchPendingLessons = async () => {
    dispatch(setPendingLessonLoading(true))
    const params = {
      InstructorId,
      StartDateTime,
      EndDateTime,
      FILTER_TYPE: 'Groups',
    }
    try {
      const res = await client.query({
        query: GET_LESSON_GROUPS,
        variables: { params },
        fetchPolicy: 'network-only',
      })

      const lessonGroup = new MyBerlitzLessonGroup(res?.data?.getLessonGroups, toUserDate)
      dispatch(setPendingLessons(lessonGroup))
    } catch (e) {
      dispatch(setPendingLessonError(true))
    }
  }

  useEffect(() => {
    fetchPendingLessons()
  }, [])

  return null
}

export default withApollo(WithUserTime(PendingLessonsTabQuery))
